import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import useStorage from '@/shared/hooks/use-storage';
import { QUERY_KEYS } from '@/features/auth/constants';
import { authRefreshToken } from '@/features/auth/services/refresh-token';
import useAuth from '@/features/auth/hooks/use-auth';

type UseRefreshTokenProps = {
  interval: number;
};

const useRefreshToken = (config: UseRefreshTokenProps) => {
  const { store } = useStorage();
  const { logout } = useAuth();

  const query = useQuery({
    queryKey: [QUERY_KEYS.AUTH_REFRESH],
    queryFn: async () => {
      const { refreshToken } = (await store.getAuth()) || {};
      return refreshToken && authRefreshToken({ refreshToken });
    },
    refetchInterval: config.interval,
    refetchOnWindowFocus: false,
    retry: false,
  });

  // Handle error: logout when refresh token fails
  useEffect(() => {
    if (query.error) {
      logout();
    }
  }, [query.error, logout]);

  return query;
};

export default useRefreshToken;
